<template>
    <div class="jxwj" v-loading.fullscreen.lock="loading">
        <p class="title">CMS配置</p>
        <el-form :label-position="labelPosition" label-width="280px" :model="formLabelAlign">
            <el-form-item label="使用cms政府公开:">
                <el-input v-model="cmsId" placeholder="请输入政府公开的columId"></el-input>
            </el-form-item> 
        </el-form>
        <div class="center">
            <el-button style="margin:0 auto" @click="save">确定</el-button>
        </div>
    </div>
</template>

<script>
    import {
        getCmsProfile,
        postCmsProfile
    } from "@/api/zone.js";
    export default {
        name: "jxwj",
        data() {
            return {
                cmsId:''
            };
        },
        mounted() {
        },
        created() {
            this.init()
        },
        methods: {
            init() {
                getCmsProfile().then(res=>{
                    if(res.status == 0){
                        this.cmsId = res.zfgkColumnId
                    }
                })
            },
            save(){
                postCmsProfile({
                    zfgkColumnId:this.cmsId
                }).then(res=>{
                    if(res.status == 0){
                        this.$message.success('使用成功')
                    }
                })
            }
        },
    };
</script>

<style scoped>
    .configtime /deep/.el-input {
        width: 270px;
    }
    .jxwj {
        width: 100%;
        padding: 50px;
    }

    /deep/ .el-form-item__label {
        font-size: 20px;
        font-weight: bold;
    }

    .title {
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 50px;
    }
.center{
    display: flex;
    justify-content: center;
}
</style>
